<template>
  <Teleport to="body">
    <div
      v-if="isVisible"
      class="modal-backdrop fade show"
    ></div>

    <div
      class="modal fade"
      :class="{ show: isVisible }"
      :style="{ display: isVisible ? 'block' : 'none' }"
      tabindex="-1"
      :aria-hidden="!isVisible"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-warning">
            <h5 class="modal-title">
              <span class="material-icons me-2" style="vertical-align: middle;">sync_alt</span>
              {{ $t('plan_trail.reverse_redraw_modal.reverse_route') }}
            </h5>
          </div>
          <div class="modal-body">
            <!-- Literal keys: the client bundle only ships keys a t() call names. -->
            <p v-if="kind === 'cycling_and_driving'" class="mb-0">{{ $t('plan_trail.reverse_redraw_modal.contains_cycling_and_driving') }}</p>
            <p v-else-if="kind === 'cycling'" class="mb-0">{{ $t('plan_trail.reverse_redraw_modal.contains_cycling') }}</p>
            <p v-else class="mb-0">{{ $t('plan_trail.reverse_redraw_modal.contains_driving') }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="cancel">{{ $t('shared.cancel_2') }}</button>
            <button type="button" class="btn btn-primary" @click="confirm">{{ $t('shared.continue') }}</button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { defineComponent, ref } from 'vue';
import { reverseRedrawKind } from '../services/reverseRedraw';

export default defineComponent({
  setup() {
    const isVisible = ref(false);
    const kind = ref('driving');
    const resolveCallback = ref(null);

    function show(profiles) {
      return new Promise((resolve) => {
        kind.value = reverseRedrawKind(profiles);
        resolveCallback.value = resolve;
        isVisible.value = true;
      });
    }

    function close(confirmed) {
      isVisible.value = false;
      if (resolveCallback.value) {
        resolveCallback.value(confirmed);
        resolveCallback.value = null;
      }
    }

    return {
      isVisible,
      kind,
      show,
      confirm: () => close(true),
      cancel: () => close(false)
    };
  }
});
</script>

<style scoped>
.bg-warning {
  background-color: #fddf00 !important;

  h5 {
    color: var(--dark) !important;
  }
}

.modal-header .material-icons {
  font-size: 24px;
}
</style>
